/* eslint-disable no-confusing-arrow */
import config from '../../config/config';
import { toCamelCase, toSnakeCase } from './caseConverter';

const debug = require('debug')('jp:api:client');

const methods = ['get', 'post', 'put', 'patch', 'del'];

function formatUrl(path) {
  const adjustedPath = path[0] !== '/' ? `/${path}` : path;

  if (__SERVER__) {
    if (config.apiPort && config.apiPort.length > 0) {
      return `${config.apiProtocol}://${config.apiHost}:${
        config.apiPort
      }/api${adjustedPath}`;
    }
    // Prepend host and port of the API server to the path.
    return `${config.apiProtocol}://${config.apiHost}/api${adjustedPath}`;
  }
  // Prepend `/api` to relative URL, to proxy to API server.
  return `/api${adjustedPath}`;
}

export default class ApiClient {
  constructor(req, superagent) {
    methods.forEach(
      // eslint-disable-next-line no-return-assign
      method =>
        (this[method] = (
          path,
          { params, data, type, disableRequestTransform = false } = {}
        ) =>
          new Promise((resolve, reject) => {
            const formattedUrl = formatUrl(path);
            debug('request', formattedUrl);

            const request = superagent[method](formattedUrl);

            request.set('jp-api-key', process.env.JP_API_KEY || 'NoKeySet');
            request.set('Accept', 'application/json');
            request.set('Content-Type', 'application/json');

            if (params) {
              request.query(params);
            }

            if (__SERVER__ && req.get('cookie')) {
              request.set('cookie', req.get('cookie'));
            }

            if (__SERVER__ && req.get('user-agent')) {
              request.set('user-agent', req.get('user-agent'));
            }

            if (data) {
              request.send(disableRequestTransform ? data : toSnakeCase(data));
            }

            if (type) {
              request.type(type);
            }

            request.end((err, res) => {
              if (!err) {
                debug('request:success', formattedUrl, res.headers);
              }

              if (err && err.response) {
                debug(
                  'request:failed',
                  err.response.headers,
                  err.response.body
                );
              }

              if (!config.isTesting) {
                if (
                  res &&
                  res.status === 200 &&
                  res.headers['content-type'].indexOf('text/html') === 0
                ) {
                  resolve(res.text);
                }
              }

              if (res || err.response) {
                return err
                  ? reject(toCamelCase(err.response.body) || err)
                  : resolve(toCamelCase(res.body));
              }

              return reject(new Error('No API response'));
            });
          }))
    );
  }

  /*
   * There's a V8 bug where, when using Babel, exporting classes with only
   * constructors sometimes fails. Until it's patched, this is a solution to
   * "ApiClient is not defined" from issue #14.
   * https://github.com/erikras/react-redux-universal-hot-example/issues/14
   *
   * Relevant Babel bug (but they claim it's V8): https://phabricator.babeljs.io/T2455
   *
   * Remove it at your own risk.
   */
  // eslint-disable-next-line class-methods-use-this
  empty() {}
}
